<template>
  <VaNavbar :class="[
    'app-layout-navbar pt-5 px-10', 'bg-secondary'
  ]">
    <template #left>
      <div class="left">
        <RouterLink to="/" aria-label="home page">
          <VuesticLogo />
        </RouterLink>
      </div>
      <div :class="[
        isMobile
          ? 'fixed bottom-0 left-0 right-0 z-50 bg-white p-4 shadow-md'
          : 'flex-grow min-w-[300px] max-w-[100%] overflow-hidden'
      ]">
        
      </div>

    </template>
    <template #center>
      <b>{{ user }}</b>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'
import VuesticLogo from '../VuesticLogo.vue'
import Chat from '../../pages/chat/Chat.vue'
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useUserStore } from '../../stores/user'

const width = ref(window.innerWidth)

const isMobile = ref(false)
const isDesktop = ref(false)

const userX = useUserStore()
const user = ref('')
watch(()=>userX.currentUser, ({name,email})=>{
  user.value = `${name} - ${email}`;
})

function checkWidth() {
  width.value = window.innerWidth
  isMobile.value = width.value <= 820
  isDesktop.value = width.value > 820
}

onMounted(() => {
  checkWidth()
  window.addEventListener('resize', checkWidth)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkWidth)
})

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 480px) {
    .left {
      width: 10%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;
  flex-shrink: 0;
  min-width: fit-content;

  &>* {
    margin-right: 0.5rem;
  }

  &>*:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
